__turbopack_context__.v({
  "root": "ContentLoader-module-scss-module__lov1ra__root",
});
